import { subDays } from 'date-fns';
import { useEffect, useState } from "react";
import { db } from "../../services/firebase";
import {collection, Timestamp, query, where, onSnapshot, orderBy, limit} from "@firebase/firestore";
import EnhancedTable from "../../components/dense-table/DenseTable";
import {useAuth} from "../../providers/AuthProvider";
import {hasAnyGrant} from "../../services/shared";
import { Alert } from "@mui/material";

function buildLeadsQuery(db: any, uid: string, grants: string[]) {
  const colRef = collection(db, "leads");
  const thirtyDaysAgo = subDays(new Date(), 30);

  // Condizione di base sempre valida
  const conditions: any[] = [
    where("createdAt", ">=", Timestamp.fromDate(thirtyDaysAgo)),
  ];

  // Se NON ha quality_op o user_admin, allora filtra solo le sue lead
  if (!hasAnyGrant(grants, ["quality_op", "admin"])) {
    conditions.push(where("uidSender", "==", uid));
  }

  conditions.push(orderBy("createdAt", "desc"));
  conditions.push(limit(1000));

  return query(colRef, ...conditions);
}

export default function LeadList() {
  const { user, grants } = useAuth();
  const [leadsAttesaConferma, setLeadsAttesaConferma] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isCapped, setIsCapped] = useState<boolean>(false);
  const isProduction = true;

  useEffect(() => {
    if (!user?.uid || !grants?.length) return;

    const q = buildLeadsQuery(db, user.uid, grants);
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const data = querySnapshot.docs.map((d) => ({
        uid: d.id,
        nominativo: `${d.data().nome.toUpperCase()} ${d.data().cognome.toUpperCase()}`,
        nome: d.data().nome,
        cognome: d.data().cognome,
        cellulare: d.data().cellulare,
        status: d.data().status,
        shortLink: d.data().shortLink,
        createdAt: d.data().createdAt?.toDate ? d.data().createdAt.toDate() : new Date(), // fallback
        uidSender: d.data().uidSender
      }));
      // console.log({ data });
      setLeadsAttesaConferma(data);
      setIsCapped(data.length === 1000);
      setLoading(false);
    }, (err) => {
      console.error("Errore nel listener realtime:", err);
      setError("Errore nel caricamento dei lead. Riprova più tardi.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user?.uid, grants]);

  return (
    <div className="container">
      <div className="flex-col">
        <div className="flex-row gap-2" style={{alignItems: "center", marginTop: "1em"}}>
          <h3>📌 Lista Lead</h3>
        </div>
        <div>
          {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
          {isCapped && <Alert severity="info" sx={{ mb: 1 }}>Visualizzando gli ultimi 1000 lead. Usa i filtri per restringere.</Alert>}
          {loading ? (
              <p>Caricamento...</p>
          ) : (
              <EnhancedTable data={leadsAttesaConferma}/>
          )}
        </div>
      </div>
    </div>
  );
}
